export default {
  title: 'Contact și sincronizare',
  labels: {
    occ_phone_number: 'Număr de telefon call center',
    company_phone_number: 'Număr de telefon restaurant',
    has_google_business_sync: 'Sincronizare cu Google Business',
    has_foodamigos_sync: 'Sincronizare cu serviciile Fooodamigos',
  },
  placeholders: {
    occ_phone_number: 'Selectați numărul de telefon din listă',
  },
};
